import { Component } from '@angular/core';
import { catchError, finalize, tap } from 'rxjs';
import { DashboardService } from '../../../../services/dashboard/dashboard.service';
import { AppService } from '../../../../app.service';
import { isArrayWithData } from '../../../../utilities/array.helpers';

export interface IngestionRow {
    status: 'Success' | 'Failed';
    id: number;
    file: string;
    start: Date;

    totalRecords: number;
    invoices: number;
    contacts: number;
    voided: number;
    voidedRate: number;
}

@Component({
    selector: 'app-dashboard',
    templateUrl: './landing-dashboard.component.html',
    styleUrl: './landing-dashboard.component.css',
})
export class LandingDashboardComponent {
    constructor(
        private dashboardService: DashboardService,
        public appService: AppService,
    ) {}

    creditors: any[] | undefined;
    timezones: any[] = [];

    countReturnedLookups: number = 0;
    activeIndex: number = 0;

    ngOnInit() {
        this.appService.isShowPageSpinner = true;
        this.getLookupsGeneral();
    }

    incrementLookupsCount() {
        this.countReturnedLookups++;
        if (this.countReturnedLookups === 2) {
            this.appService.isShowPageSpinner = false;
        }
    }

    getLookupsGeneral() {
        this.getCreditors();
        this.getTimezones();
    }

    getCreditors() {
        this.dashboardService
            .getCreditors()
            .pipe(
                tap((res: any) => {
                    if (isArrayWithData(res)) {
                        this.creditors = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.incrementLookupsCount();
                }),
            )
            .subscribe();
    }

    getTimezones() {
        this.dashboardService
            .getTimezones()
            .pipe(
                tap((res: any) => {
                    if (isArrayWithData(res)) {
                        this.timezones = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.incrementLookupsCount();
                }),
            )
            .subscribe();
    }
}
